import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { DatePicker } from '@material-ui/pickers';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  option: {
    margin: 5
  },
  date: {
    margin: 5
  }
}));

const PeerInvestDatePicker = ({ since, setSince }) => {
  const [selectedDate, handleDateChange] = useState(new Date());
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {!since && (
        <DatePicker
          className={classes.date}
          onAccept={setSince}
          onChange={handleDateChange}
          openTo="year"
          value={selectedDate}
          views={['year', 'month']}
        />
      )}
      {since && (
        <Typography className={classes.option} color="initial" variant="h6">
          {since}
        </Typography>
      )}
    </div>
  );
};

export default PeerInvestDatePicker;
